<template>
    <dv-full-screen-container>
        <div class="linea-mainContainer">
            <div class="mainHead">
                <div class="headLeft">
                    <dv-decoration-8 :color="['#47A8ED', '#47A8ED']" style="width: 500px; height: 50px" />
                </div>
                <div class="middleOfHead">
                    <div class="headerText">
                        <img alt="塑业实时数据大屏" src="@/assets/img/logo.png" />
                        <p>塑业实时数据大屏</p>
                    </div>
                    <dv-decoration-5 :color="['#47A8ED', '#47A8ED']" :dur="10" style="width: 700px; height: 40px" />
                </div>
                <div class="headRight">
                    <dv-decoration-8
                        :color="['#47A8ED', '#47A8ED']"
                        :reverse="true"
                        style="width: 500px; height: 50px"
                    />
                </div>
            </div>
            <div class="contentBox">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="leftBox">
                            <div class="upperLeft">
                                <dv-border-box-12 :color="['#0E4E80', '#1A92E8']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="upperLeftBox">
                                        <div class="titleGroup">
                                            <div class="titleBox">电机控制台</div>
                                            <div class="toggleButtonGroup">
                                                <a
                                                    :class="motorTabActive === 0 ? 'toggleActivation' : ''"
                                                    @click="motorTabActive = 0"
                                                >
                                                    实时值
                                                </a>
                                                <span>丨</span>
                                                <a
                                                    :class="motorTabActive === 1 ? 'toggleActivation' : ''"
                                                    @click="motorTabActive = 1"
                                                >
                                                    设定值
                                                </a>
                                            </div>
                                        </div>
                                        <div class="contentGroup" v-if="motorTabActive === 0">
                                            <li>
                                                <p>
                                                    主机转速实时：<span>{{ lineC.motor.data10 }}</span>
                                                </p>
                                                <p>
                                                    主机转矩A：<span>{{ lineC.motor.data101 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机转矩%：<span>{{ lineC.motor.data102 }}</span>
                                                </p>
                                                <p>
                                                    牵引速度实时：<span>{{ lineC.motor.data104 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    牵引转矩：<span>{{ lineC.motor.data105 }}</span>
                                                </p>
                                                <p>
                                                    共挤速度实时：<span>{{ lineC.blanking.data2 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    供挤转矩：<span>{{ lineC.blanking.data19 }}</span>
                                                </p>
                                                <p>
                                                    挤出产量实时：<span>{{ lineC.motor.data106 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    每米重实时：<span>{{ lineC.motor.data108 }}</span>
                                                </p>
                                                <p>
                                                    速比：<span>{{ lineC.motor.data106 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    熔体温度：<span>{{ lineC.xian.tc115 }}</span>
                                                </p>
                                                <p>
                                                    熔体压力：<span>{{ lineC.motor.data103 }}</span>
                                                </p>
                                            </li>
                                        </div>
                                        <div class="contentGroup" v-if="motorTabActive === 1">
                                            <li>
                                                <p>
                                                    主机速度设定：<span>{{ lineC.motor.data1 }}</span>
                                                </p>
                                                <p>
                                                    牵引速度设定：<span>{{ lineC.motor.data9 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    共挤速度设定：<span>{{ lineC.blanking.data1 }}</span>
                                                </p>
                                                <p>
                                                    挤出产量设定：<span>{{ lineC.motor.data10 }}</span>
                                                </p>
                                            </li>
                                        </div>
                                    </div>
                                </dv-border-box-12>
                            </div>

                            <div class="lowerLeft" style="height: 100%">
                                <dv-border-box-12 :color="['#0E4E80', '#1A92E8']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="lowerLeftBox">
                                        <div class="titleGroup">
                                            <div class="titleBox">参数信息</div>
                                        </div>
                                        <ul v-if="infoTabActive === 0" class="contentGroup">
                                            <li>
                                                <p>
                                                    主机最高速度：<span>{{ lineC.motor.data2 }}</span>
                                                </p>
                                                <p>
                                                    主机最大电流：<span>{{ lineC.motor.data3 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    牵引最高速度：<span>{{ lineC.blanking.data16 }}</span>
                                                </p>
                                                <p>
                                                    熔体最高压力：<span>{{ lineC.motor.data12 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机报警转矩：<span>{{ lineC.motor.data4 }}</span>
                                                </p>
                                                <p>
                                                    主机停机转矩：<span>{{ lineC.motor.data5 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    供挤最高速度：<span>{{ lineC.blanking.data17 }}</span>
                                                </p>
                                                <p>
                                                    保温度时间：<span>{{ lineC.motor.data9 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机微调系数：<span>{{ lineC.motor.data6 }}</span>
                                                </p>
                                                <p>
                                                    牵引微调系数：<span>{{ lineC.blanking.data18 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    报警压力：<span>{{ lineC.blanking.data20 }}</span>
                                                </p>
                                                <p>
                                                    停机压力：<span>{{ lineC.motor.data8 }}</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </dv-border-box-12>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="middleBox">
                            <div class="upperMiddle">
                                <line-change-moudle />
                                <div class="floorPlan">
                                    <img alt="" src="../../assets/img/plan/plan@2x.png" />
                                </div>
                            </div>
                            <div class="middleDown">
                                <dv-border-box-11 :color="['#47A8ED', '#2972A6']" title="温度观测台">
                                    <div class="swiper-box">
                                        <swiper ref="mySwiper" :options="swiperOptions">
                                            <swiper-slide>
                                                <div class="temperatureGroup">
                                                    <template v-for="index in 5">
                                                        <temp-c
                                                            :key="'c1' + index"
                                                            :name="`EH${index}`"
                                                            :choose="lineC.sw[`sweh${index}`]"
                                                            :start-stop="lineC.sw[`sweh${index}`]"
                                                            :heating-state="lineC.sw[`sweh${index}`]"
                                                            :set-temp="lineC.xian[`tc${index}`]"
                                                            :current-temp="lineC.xian[`tc${index + 100}`]"
                                                        />
                                                    </template>
                                                    <template v-for="index in 5">
                                                        <temp-c
                                                            :key="'c2' + index"
                                                            :name="`ED${index}`"
                                                            :choose="lineC.sw[`sw${index + 5}`]"
                                                            :start-stop="lineC.sw[`swed${index}`]"
                                                            :heating-state="lineC.sw[`swed${index}`]"
                                                            :set-temp="lineC.xian[`tc${index + 5}`]"
                                                            :current-temp="lineC.xian[`tc${index + 105}`]"
                                                        />
                                                    </template>
                                                </div>
                                            </swiper-slide>
                                            <swiper-slide>
                                                <div class="temperatureGroup">
                                                    <temp-c
                                                        name="ED6"
                                                        :choose="lineC.sw.sw11"
                                                        :start-stop="lineC.sw.swed6"
                                                        :heating-state="lineC.sw.swed6"
                                                        :set-temp="lineC.xian.tc11"
                                                        :current-temp="lineC.xian.tc111"
                                                    />
                                                    <template v-for="index in 3">
                                                        <temp-c
                                                            :key="'c3' + index"
                                                            :name="`ED${index + 6}`"
                                                            :choose="lineC.sw[`swed${index + 6}`]"
                                                            :start-stop="lineC.sw[`swed${index + 6}`]"
                                                            :heating-state="lineC.sw[`swed${index + 6}`]"
                                                            :set-temp="lineC.xian[`tc${index + 11}`]"
                                                            :current-temp="lineC.xian[`tc${index + 111}`]"
                                                        />
                                                    </template>
                                                </div>
                                            </swiper-slide>
                                            <div slot="pagination" class="paginationDiy swiper-pagination"></div>
                                        </swiper>
                                    </div>
                                </dv-border-box-11>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="rightBox">
                            <div class="upperRight" style="height: 100%">
                                <dv-border-box-12 :color="['#0E4E80', '#2972A6']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="upperRightBox">
                                        <div class="titleBox">米重控制台</div>
                                        <div class="contentGroup">
                                            <li>
                                                <p>
                                                    每米重设定值：
                                                    <span>{{ lineC.motor.data11 }}</span>
                                                </p>
                                                <p>
                                                    挤出产量设定值：
                                                    <span>{{ lineC.motor.data10 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机转速设定值：
                                                    <span>{{ lineC.motor.data1 }}</span>
                                                </p>
                                                <p>
                                                    牵引速度设定：
                                                    <span>{{ lineC.motor.data9 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    共挤速度设定：
                                                    <span>{{ lineC.blanking.data1 }}</span>
                                                </p>
                                                <p>
                                                    主机转矩：
                                                    <span>{{ lineC.motor.data102 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    熔体压力：
                                                    <span>{{ lineC.motor.data103 }}</span>
                                                </p>
                                                <p>
                                                    每米重实时值：
                                                    <span>{{ lineC.motor.data107 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    挤出产量实时：
                                                    <span>{{ lineC.motor.data106 }}</span>
                                                </p>
                                                <p>
                                                    主机转速实时：
                                                    <span>{{ lineC.motor.data100 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    牵引速度实时：
                                                    <span>{{ lineC.motor.data104 }}</span>
                                                </p>
                                                <p>
                                                    共挤速度实时：
                                                    <span>{{ lineC.blanking.data2 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    管材外径设定：
                                                    <span>{{ lineC.blanking.data3 }}</span>
                                                </p>
                                                <p>
                                                    管材密度设定：
                                                    <span>{{ lineC.blanking.data4 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    平均壁厚设定：
                                                    <span>{{ lineC.blanking.data5 }}</span>
                                                </p>
                                                <p>
                                                    每米重设定：
                                                    <span>{{ lineC.motor.data11 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    挤出产量设定：
                                                    <span>{{ lineC.motor.data10 }}</span>
                                                </p>
                                                <p>
                                                    累计产量：
                                                    <span>{{ lineC.motor.data113 }}</span>
                                                </p>
                                            </li>

                                            <li>
                                                <p>
                                                    当班产量：
                                                    <span>{{ lineC.motor.data112 }}</span>
                                                </p>
                                                <p>
                                                    每米重实时：
                                                    <span>{{ lineC.motor.data107 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    挤出产量实时：
                                                    <span>{{ lineC.motor.data106 }}</span>
                                                </p>
                                                <p>
                                                    空料斗重量设定值：
                                                    <span>{{ lineC.blanking.data6 }}</span>
                                                </p>
                                            </li>

                                            <li>
                                                <p>
                                                    校准系数设定值：
                                                    <span>{{ lineC.blanking.data7 }}</span>
                                                </p>
                                                <p>
                                                    接近开关数设定值：
                                                    <span>{{ lineC.blanking.data8 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    牵引稳定系数：
                                                    <span>{{ lineC.blanking.data9 }}</span>
                                                </p>
                                                <p>
                                                    编码器校准系数设定值：
                                                    <span>{{ lineC.blanking.data10 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    米重调整比例设定值：
                                                    <span>{{ lineC.blanking.data11 }}</span>
                                                </p>
                                                <p>
                                                    米重调整时间0.1s设定值：
                                                    <span>{{ lineC.blanking.data12 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    米重调整区间设定值：
                                                    <span>{{ lineC.blanking.data13 }}</span>
                                                </p>
                                                <p>
                                                    米重调整等待区间设定值：
                                                    <span>{{ lineC.blanking.data14 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    牵引精度范围%设定值：
                                                    <span>{{ lineC.blanking.data15 }}</span>
                                                </p>
                                                <p>
                                                    牵引稳定系数实时值：
                                                    <span>{{ lineC.blanking.data9 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    当前AD值：
                                                    <span>{{ lineC.motor.data110 }}</span>
                                                </p>
                                                <p>
                                                    当前下料率：
                                                    <span>{{ lineC.motor.data111 }}</span>
                                                </p>
                                            </li>
                                        </div>
                                    </div>
                                </dv-border-box-12>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </dv-full-screen-container>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import { GET_LINE_C } from "@/api/public";
import TempC from "./components/Temp/TempC.vue";
import LineChangeMoudle from "./components/LineChangeMoudle.vue";

export default {
    name: "LineC",
    components: {
        Swiper,
        SwiperSlide,
        TempC,
        LineChangeMoudle
    },
    data() {
        return {
            lineC: {
                blanking: {
                    data1: 0,
                    data2: 0,
                    data3: 0,
                    data4: 0,
                    data5: 0,
                    data6: 0,
                    data7: 0,
                    data8: 0,
                    data9: 0,
                    data10: 0,
                    data11: 0,
                    data12: 0,
                    data13: 0,
                    data14: 0,
                    data15: 0,
                    data16: 0,
                    data17: 0,
                    data18: 0,
                    data19: 0,
                    data20: 0
                },
                motor: {
                    data1: 0,
                    data2: 0,
                    data3: 0,
                    data4: 0,
                    data5: 0,
                    data6: 0,
                    data7: 0,
                    data8: 0,
                    data9: 0,
                    data10: 0,
                    data11: 0,
                    data12: 0,
                    data100: 0,
                    data101: 0,
                    data102: 0,
                    data103: 0,
                    data104: 0,
                    data105: 0,
                    data106: 0,
                    data107: 0,
                    data108: 0,
                    data109: 0,
                    data110: 0,
                    data111: 0,
                    data112: 0,
                    data113: 0
                },
                line: {},
                xian: {},
                sw: {}
            },
            swiperOptions: {
                autoplay: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            },
            // 切料控制台tab
            cuttingTabActive: 0,
            // 参数信息tab
            infoTabActive: 0,
            // 电机控制台tab
            motorTabActive: 0
        };
    },
    mounted() {
        this.getLineA();
        setInterval(() => {
            this.getLineA();
        }, 60000);
    },
    methods: {
        getLineA() {
            GET_LINE_C({}).then((res) => {
                if (Number(res.data.code) !== 10000) {
                    this.$message.error(res.data.message);
                    return false;
                }
                this.lineC = res.data.data;
                console.log(res.data.data);
            });
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/style/lineA.scss";
</style>
